angular
	.module 'App.Repository'

.factory 'PaymentSubscriptionRepository', ['BaseRepository', (BaseRepository) ->
	class PaymentSubscriptionRepository extends BaseRepository
		@resource = '/payment_subscriptions'
		@isRestricted = true

	return new PaymentSubscriptionRepository
]
